import {BuiltInControlTypes} from '../../../constants/BuiltInControlTypes';
import {TextBuiltInControl} from '../TextBuiltInControl';

/**
 * @description base class including general text size modifications logic
 */
export abstract class TextSizeBuiltInControl extends TextBuiltInControl {
  public getParentControlId(): string {
    return BuiltInControlTypes.GENERAL.TEXT_SIZE;
  }
}
